export default class Turnstile {
    constructor(sitekey) {
        this.sitekey = sitekey
    }

    renderTurnstile(elementId) {
        if (!window.turnstile) {
            this.loadTurnstileScript().then(() => {
                this.initializeTurnstile(elementId)
            })
        } else {
            this.initializeTurnstile(elementId)
        }
    }

    initializeTurnstile(elementId) {
        window.turnstile.render(elementId, {
            sitekey: this.sitekey,
            theme: 'light'
        })
    }

    loadTurnstileScript() {
        return new Promise((resolve) => {
            const script = document.createElement('script')
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=_turnstileCb'
            script.defer = true
            script.onload = resolve
            document.head.appendChild(script)
        })
    }
}
